import { render, staticRenderFns } from "./TypeManagement.vue?vue&type=template&id=f8b062e6&"
import script from "./TypeManagement.vue?vue&type=script&lang=js&"
export * from "./TypeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports